import styled from 'styled-components';
import { scale, variant } from '@magalu/stereo-ui-styles';
import { Flex } from '@magalu/stereo-ui/atoms';
export const Container = styled(Flex).attrs({
  position: 'relative',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  width: '100%',
  px: 2
})(({
  count
}) => count === 3 && {
  '& > *:nth-child(2)': {
    position: 'absolute',
    left: '50%',
    top: '50%',
    height: '100%',
    transform: 'translate(-50%,-50%)'
  }
}, variant, scale);